// Conversion machines use an R followed by exactly two digits (for example R04 or R12).
export const isConversionMachine = (machine) =>
  /^R\d{2}$/i.test(String(machine?.code || '').trim());
